/* eslint-disable max-len */
import { FunctionComponent, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  useGlobalDispatch, useGlobalState,
} from '../../contexts';
import LinkComp from './LinkComp';
import LogOutAdmin from './LogOutAdmin';

// import AdminNewLogo from '../../svgs/AdminNewLogo';
import LogsIcon from '../../svgs/LogsIcon';
// import LoansIcon from '../../svgs/LoansIcon';
import CustomersIcon from '../../svgs/CustomersIcon';
import TransactionIconAdmin from '../../svgs/TransactionIconAdmin';
// import RepaymentIcon from '../../svgs/RepaymentIcon';
import NoAccessIcon from '../../svgs/NoAccessIcon';
// import RentCollectionIcon from '../../svgs/RentCollectionIcon';
import RewardIcon from '../../svgs/RewardIcon';

import './SideBar.scss';
import SidebarSettingsIcon from '../../svgs/SidebarSettingsIcon';
import KaboLogo from '../../svgs/KaboLogo';
// import HomeIcon from '../../svgs/HomeIcon';
// import BillsPaymentSidebarIcon from '../../svgs/BillsPaymentSidebarIcon';
// import InfoIcon from '../../svgs/InfoIcon';

export interface ISideBar {
  disabled?: boolean;
  closeDropDownAndSideBar?: () => void;
}

const AdminSideBar: FunctionComponent<ISideBar> = ({ disabled, closeDropDownAndSideBar }) => {
  const { clearUser } = useGlobalDispatch();
  const { profile } = useGlobalState();

  const [subTabDropdown, setSubTabDropdown] = useState(false);
  const [activeTabName, setActiveTabName] = useState('');
  const [logOutModal, setLogOutModal] = useState(false);
  const adminPermissions = profile?.role?.permissions?.map((permission) => permission.name);

  const { push } = useHistory();

  const Logout = () => {
    clearUser();
    push('/');
  };

  const TabsList = [
    {
      disabled,
      icon: CustomersIcon,
      link: '/customers',
      name: 'Customers',
      permission: [
        'can-view-all-customers',
        'can-view-approved-customers',
        'can-view-prospective-customers',
        'can-view-priority-customers',
        'can-view-declined-customers',
        'can-view-deleted-customers',
        'can-view-product-analysis',
      ],
      subTabs: [
        {
          disabled,
          link: '/customers/overview?page=1',
          name: 'Customer Overview',
          permission: [
            'can-view-all-customers',
            'can-view-approved-customers',
            'can-view-prospective-customers',
            'can-view-priority-customers',
            'can-view-declined-customers',
            'can-view-deleted-customers',
          ],
        },
        {
          disabled,
          link: '/customers/product-preference',
          name: 'Product Preference',
          permission: [
            'can-view-all-customers',
            'can-view-approved-customers',
            'can-view-prospective-customers',
            'can-view-priority-customers',
            'can-view-declined-customers',
            'can-view-deleted-customers',
          ],
        },
        {
          disabled,
          link: '/customers/product-analysis',
          name: 'Product Analysis',
          permission: ['can-view-product-analysis'],
        },
      ],
    },
    {
      disabled,
      icon: TransactionIconAdmin,
      link: '/transactions?page=1',
      name: 'Transactions',
      permission: [
        'can-view-all-transactions',
        'can-view-all-transaction-tab',
        'can-view-pending-transaction',
        'can-view-successful-transaction',
        'can-view-failed-transaction',
        'can-view-all-wallet-transaction',
        'can-view-wallet-pending-transaction',
        'can-view-successful-wallet-transaction',
        'can-view-failed-wallet-transaction',
      ],
      subTabs: null,
    },
    // {
    //   disabled,
    //   icon: BillsPaymentSidebarIcon,
    //   link: '/bills-payment?page=1',
    //   name: 'Bills Payment',
    //   permission: ['can-get-bills-payment'],
    //   subTabs: null,
    // },
    // {
    //   disabled,
    //   icon: HomeIcon,
    //   link: '/housing-applications',
    //   name: 'Housing Applications',
    //   permission: ['can-update-apartment-search-status', 'can-view-apartment-detail'],
    // },
    // {
    //   disabled,
    //   icon: LoansIcon,
    //   link: '/loans?page=1',
    //   name: 'Credit Request',
    //   permission: ['can-view-all-credit-request', 'can-view-all-credit-request-tab', 'can-view-pending-credit-request', 'can-view-disbursed-credit-request', 'can-view-declined-credit-request', 'can-view-awaiting-approval-credit-request'],
    //   subTabs: null,
    // },
    // {
    //   disabled,
    //   icon: LoansIcon,
    //   link: '/guarantees',
    //   name: 'Guarantee Request',
    //   permission: ['can-view-all-guarantees', 'can-view-all-guarantees-tab', 'can-view-pre-approval-guarantees', 'can-view-paid-guarantees', 'can-view-awaiting-payment-guarantees', 'can-view-declined-guarantees', 'can-view-awaiting-approval-guarantees'],
    //   subTabs: [
    //     {
    //       disabled,
    //       link: '/guarantees/main?page=1',
    //       name: 'Main Guarantees',
    //       permission: ['can-view-all-guarantees', 'can-view-all-guarantees-tab', 'can-view-pre-approval-guarantees', 'can-view-paid-guarantees', 'can-view-awaiting-payment-guarantees', 'can-view-declined-guarantees', 'can-view-awaiting-approval-guarantees'],
    //     },
    //     {
    //       disabled,
    //       link: '/guarantees/pre-approval?page=1',
    //       name: 'Pre Approval Guarantees',
    //       // permission: ['can-view-pre-approval-guarantees', 'can-view-pre-approval-declined-guarantees', 'can-view-awaiting-pre-approval-guarantees', 'can-view-pre-approval-paid-guarantees'],
    //       permission: ['can-view-pre-approval-guarantees', 'can-view-all-guarantees-tab', 'can-view-pre-approval-guarantees', 'can-view-paid-guarantees', 'can-view-awaiting-payment-guarantees', 'can-view-declined-guarantees', 'can-view-awaiting-approval-guarantees'],
    //     },
    //   ],
    // },
    // {
    //   disabled,
    //   icon: RentCollectionIcon,
    //   link: '/rent-collection?page=1',
    //   name: 'Rent Collection',
    //   permission: ['can-view-rent-payment', 'can-update-rent-payment-settlement-status'],
    //   subTabs: null,
    // },
    // {
    //   disabled,
    //   icon: InfoIcon,
    //   link: '/equifax-reports?page=1',
    //   name: 'Equifax Reports',
    //   permission: ['can-update-rent-payment-settlement-status'],
    //   subTabs: null,
    // },
    // {
    //   disabled,
    //   icon: RepaymentIcon,
    //   link: '/repayments?page=1',
    //   name: 'Repayments',
    //   permission: ['can-get-repayments', 'can-get-repayment-by-id', 'can-view-due-repayments', 'can-view-upcoming-repayments', 'can-view-defaulting-repayments', 'can-view-paid-repayments'],
    //   subTabs: null,
    // },
    {
      disabled,
      icon: RewardIcon,
      link: '/rewards',
      name: 'Referrals',
      // permission: ['can-get-repayments', 'can-view-all-repayments', 'can-view-due-repayments', 'can-view-upcoming-repayments', 'can-view-defaulting-repayments', 'can-view-paid-repayments'],
      subTabs: [
        {
          disabled,
          link: '/rewards/statistics?page=1',
          name: 'Referral Statistics',
        },
        {
          disabled,
          link: '/rewards/realtors-tracking-code?page=1',
          name: 'Realtor’s Tracking Code',
        },
        {
          disabled,
          link: '/rewards/partners-tracking-code?page=1',
          name: 'Partner’s Tracking Code',
        },
        {
          disabled,
          link: '/rewards/partner-coupons?page=1',
          name: 'Partner coupons',
        },
      ],
    },
    {
      disabled,
      icon: SidebarSettingsIcon,
      link: '/settings',
      name: 'Settings',
      permission: ['can-get-roles'],
      subTabs: null,
    },
  ];

  const footerNavs = [
    {
      disabled,
      icon: LogsIcon,
      link: '',
      name: 'Logout',
      shouldNotBeActive: true,
    },
  ];

  const permissionWithArray = (permissionData:any) => {
    const checkIfPermissionExist = permissionData?.find((list:any) => adminPermissions?.includes(list));
    if (checkIfPermissionExist) {
      return true;
    }
    return false;
  };

  const hasPermission = (permission: any) => {
    const permissionIsArray = Array.isArray(permission);
    if (permissionIsArray) {
      return permissionWithArray(permission);
    }
    return !permission
      || adminPermissions?.includes(permission);
  };

  return (
    <div className="admin-sidebar-cover">
      <div className="admin-logo-cover">
        <KaboLogo className="admin-logo" />
      </div>
      <div className="admin-tabs-root-cover">
        <div className="admin-tabs-cover">
          <ul>
            {
              TabsList?.map((list, i) => (
                <LinkComp
                  key={i}
                  disabled={list?.disabled || !hasPermission(list?.permission)}
                  Icon={list?.icon}
                  name={list?.name}
                  link={list?.link}
                  closeDropDownAndSideBar={closeDropDownAndSideBar}
                  subTabs={list?.subTabs}
                  subTabDropdown={subTabDropdown}
                  setSubTabDropdown={setSubTabDropdown}
                  setActiveTabName={setActiveTabName}
                  activeTabName={activeTabName}
                />
              ))
            }
          </ul>
        </div>
        <div className="admin-footer-cover">
          <div className="admin-footer-line" />
          <div className="admin-footer-links">
            <ul>
              {
                footerNavs?.map((list: any, i) => (
                  <LinkComp
                    key={i}
                    disabled={list?.disabled || !hasPermission(list?.permission)}
                    Icon={hasPermission(list?.permission) ? list?.icon : NoAccessIcon}
                    name={list?.name}
                    link={list?.link}
                    closeDropDownAndSideBar={closeDropDownAndSideBar}
                    shouldNotBeActive={list?.shouldNotBeActive}
                    subTabDropdown={subTabDropdown}
                    setSubTabDropdown={setSubTabDropdown}
                    onClick={() => {
                      if (list?.name?.toLowerCase?.() === 'logout') {
                        // Logout();
                        setLogOutModal(true);
                      }
                    }}
                    className="admin-footer-link"
                  />
                ))
              }
            </ul>
            {
              logOutModal && (
              <LogOutAdmin
                logout={Logout}
                closeModal={() => setLogOutModal(false)}
              />
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSideBar;
